import React from "react";

export default function TAbletIcon() {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-158.46q12.38 0 21.58-9.19 9.19-9.2 9.19-21.58 0-12.39-9.19-21.58Q492.38-220 480-220q-12.38 0-21.58 9.19-9.19 9.19-9.19 21.58 0 12.38 9.19 21.58 9.2 9.19 21.58 9.19ZM224.62-80q-26.85 0-45.74-18.88Q160-117.77 160-144.62v-670.76q0-26.85 18.88-45.74Q197.77-880 224.62-880h510.76q26.85 0 45.74 18.88Q800-842.23 800-815.38v670.76q0 26.85-18.88 45.74Q762.23-80 735.38-80H224.62ZM200-258.46v113.84q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92h510.76q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-113.84H200Zm0-40h560V-740H200v441.54ZM200-780h560v-35.38q0-10.77-6.92-17.7-6.93-6.92-17.7-6.92H224.62q-10.77 0-17.7 6.92-6.92 6.93-6.92 17.7V-780Zm0 0v-60 60Zm0 521.54V-120v-138.46Z" /></svg>
    )
}


